import { type GetState } from './storeTypes';

/**
 * The clinician-visible storage warning is once per recording, not once per
 * report site: the start's steps and the mid-recording arm share this latch.
 *
 * Keyed by recording id, not a bare flag, so the next recording warns on its own
 * terms even if a reset is missed. `null` is its own key.
 */
let reported: { recordingId: string | null } | null = null;

export const reportStorageDegradedOnce = (
  get: GetState,
  recordingId: string | null,
  error: unknown
): void => {
  if (reported?.recordingId === recordingId) return;
  reported = { recordingId };
  get().config?.onStorageDegraded?.(error);
};

/** Cleared wherever `recordingId` resets, so the next recording may warn again. */
export const resetStorageDegradedReport = (): void => {
  reported = null;
};
